exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".room-image[data-v-26058f2e] .VueCarousel-inner{min-height:196px!important;max-height:196px!important}.zb-modal-box .room-image[data-v-26058f2e] .VueCarousel-inner{max-height:100%!important}@media only screen and (min-width:601px)and (max-width:1200px){.room-image[data-v-26058f2e] .VueCarousel-wrapper{overflow:hidden!important}.room-image[data-v-26058f2e] .VueCarousel-slide{max-width:unset!important}}@media(max-width:600px){.room-image[data-v-26058f2e] .VueCarousel-inner{min-height:110px!important}}", ""]);

// exports
